import styled, { css } from 'styled-components/macro';
import { Button } from '@yme/atoms/button';
import { colorBlackTransparent100, colorCoreBlack900Base } from '@yme/tokens/colors';
import { ADAPTIVE } from '@yme/tokens/screen';
import { INDENT } from '@yme/tokens/sizes';
import { Z_INDEX } from '@yme/tokens/zindex';
import { getTextStyles } from '@yme/utils/styles';
import { COEFFICIENT } from './constants';
export const View360WrapperStyled = styled.div `
  height: 100%;
  display: flex;
  align-items: center;
  position: relative;

  button {
    position: absolute;
    bottom: ${INDENT.sm};
    left: 50%;
    transform: translateX(-50%);
    z-index: ${Z_INDEX.level2};

    ${ADAPTIVE.maxWidth.mobile} {
      bottom: ${INDENT.xs};
    }
  }
`;
export const View360GuideWrapperStyled = styled.div `
  position: absolute;
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 0 ${INDENT.xs};
  box-sizing: border-box;

  top: ${({ isMobileView }) => (isMobileView ? `${INDENT.xs}` : `${INDENT.sm}`)};
`;
export const View360ContentStyled = styled.div `
  width: 100%;
  aspect-ratio: 16/9;
  position: relative;
  margin: 20px 0;
`;
export const ListStyled = styled.ol `
  list-style: none;
`;
export const ListItemStyled = styled.li `
  visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};

  cursor: ew-resize;
`;
export const View360ImageStyled = styled.img `
  position: absolute;
  left: 0;
  top: 0;
  display: block;
  height: 100%;
  object-fit: contain;
  aspect-ratio: 16/9;
  user-select: none;
`;
export const LoadingModelStyled = styled.div `
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
export const LoadingLabelStyled = styled.div `
  ${getTextStyles('Ubuntu', 500, 18, 28)}

  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl'};

  color: ${colorCoreBlack900Base};

  padding-bottom: 20px;

  color: ${colorCoreBlack900Base};
  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl;'};
`;
export const LoadingProgressStyled = styled.div `
  position: relative;
  width: 272px;
  height: 4px;
  overflow: hidden;

  background-color: ${colorBlackTransparent100};

  &::after {
    content: '';
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;

    width: ${({ uploadPercents }) => `${uploadPercents * COEFFICIENT}px`};

    ${({ isRightToLeft }) => (isRightToLeft ? 'right: 0' : 'left: 0')};
    ${({ isRightToLeft }) => isRightToLeft && 'transform: rotate(180deg)'};
    ${({ progressBarColor }) => progressBarColor && `background-color: ${progressBarColor}`};
  }
`;
export const StaticImageWrapperStyled = styled.div `
  width: 100%;
  height: 100%;
  position: relative;
`;
export const StaticImageStyled = styled.img `
  position: absolute;
  height: 100%;
  object-fit: contain;
  aspect-ratio: 16/9;
`;
export const Usage360GuideStyled = styled.div `
  ${getTextStyles('Ubuntu', 400, 16, 24)}

  text-align: center;

  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl;'}
`;
export const Usage360GuidTextStyled = styled.span `
  position: relative;

  ${({ isRightToLeft }) => isRightToLeft
    ? css `
          padding-left: ${INDENT.m};
        `
    : css `
          padding-right: ${INDENT.m};
        `}

  &::after {
    content: '';
    position: absolute;
    bottom: -3px;
    display: block;
    width: 24px;
    height: 24px;

    ${({ isRightToLeft }) => (isRightToLeft ? 'left: 0' : 'right: 0')};

    ${({ iconUrl }) => iconUrl && `background-image: url(${iconUrl})`};
  }
`;
export const ButtonStyled = styled(Button) `
  width: auto;
  max-width: 275px;
  height: auto;
`;
